import { addDays, addMonths, addWeeks, endOfMonth, endOfQuarter, endOfWeek, startOfDay, startOfMonth, startOfQuarter, startOfWeek } from 'date-fns';
import * as yup from 'yup';

export const ShortWeekdays = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};
export const formFields = {
  daysOfTheWeek: {
    label: 'Days of the Week',
    name: 'daysOfTheWeek',
    options: [
      {
        label: 'Monday',
        value: 1,
      },
      {
        label: 'Tuesday',
        value: 2,
      },
      {
        label: 'Wednesday',
        value: 3,
      },
      {
        label: 'Thursday',
        value: 4,
      },
      {
        label: 'Friday',
        value: 5,
      },
      {
        label: 'Saturday',
        value: 6,
      },
      {
        label: 'Sunday',
        value: 0,
      },
    ],
    placeholder: 'Select Days of the Week',
    required: true,
  },
  endDate: {
    label: 'End Date',
    name: 'endDate',
    placeholder: 'Select End Date',
    required: true,
  },
  endTime: {
    label: 'End Time',
    name: 'endTime',
    placeholder: 'Select End Time',
    required: true,
  },
  startDate: {
    label: 'Start Date',
    name: 'startDate',
    placeholder: 'Select Start Date',
    required: true,
  },
  startTime: {
    label: 'Start Time',
    name: 'startTime',
    placeholder: 'Select Start Time',
    required: true,
  },
  franchiseIds:{
    label: 'Associate availability with',
    name: 'franchiseIds'
  }
};

export const formSchema = () =>
  yup.object().shape({
    daysOfTheWeek: yup
      .array()
      .of(yup.number())
      .min(1, 'Please select days of the week.')
      .required('Please select days of the week.'),
    endDate: yup.string().required('Please enter end date.'),
    endTime: yup
      .string()
      .required('Please enter end time.')
      .test(
        'is-greater',
        'End time should be greater than start time.',
        function (value) {
          const { startTime } = this.parent;
          if (startTime && value) {
            const start = new Date(`01/01/2020 ${startTime}`);
            const end = new Date(`01/01/2020 ${value}`);
            return end > start;
          }
          return true;
        },
      ),
    startDate: yup.string().required('Please enter start date.'),
    startTime: yup.string().required('Please enter start time.'),
    franchiseIds: yup.array().of(yup.string()).min(1, 'Please select at least one franchise')
  });

const TODAY = 'today';
const TOMORROW = 'tomorrow';
const YESTERDAY = 'yesterday';
const THIS_WEEK = 'thisWeek';
const LAST_WEEK = 'lastWeek';
const NEXT_WEEK = 'nextWeek';
const THIS_MONTH = 'thisMonth';
const NEXT_MONTH = 'nextMonth';
const THIS_QUARTER = 'thisQuarter';
const CUSTOM = 'custom';

  export const AvailabilitySearchFilterValues = [
  { label: 'Today', value: TODAY },
  { label: 'Tomorrow', value: TOMORROW },
  { label: 'Yesterday', value: YESTERDAY },
  { label: 'This Week', value: THIS_WEEK },
  { label: 'Last Week', value: LAST_WEEK },
  { label: 'Next Week', value: NEXT_WEEK },
  { label: 'This Month', value: THIS_MONTH },
  { label: 'Next Month', value: NEXT_MONTH },
  { label: 'This Quarter', value: THIS_QUARTER },
  { label: 'Custom', value: CUSTOM },
];
const getDateRange = (startDate, endDate) => ({
  endDate,
  startDate,
});

const filterDateRanges = {
  [CUSTOM]: [(today) => today, (today) => today],
  [LAST_WEEK]: [
    (today) => startOfWeek(addWeeks(today, -1), { weekStartsOn: 1 }),
    (today) => endOfWeek(addWeeks(today, -1), { weekStartsOn: 1 }),
  ],
  [NEXT_MONTH]: [
    (today) => startOfMonth(addMonths(today, 1)),
    (today) => endOfMonth(addMonths(today, 1)),
  ],
  [NEXT_WEEK]: [
    (today) => startOfWeek(addWeeks(today, 1), { weekStartsOn: 1 }),
    (today) => endOfWeek(addWeeks(today, 1), { weekStartsOn: 1 }),
  ],
  [THIS_MONTH]: [(today) => startOfMonth(today), (today) => endOfMonth(today)],
  [THIS_QUARTER]: [
    (today) => startOfQuarter(today),
    (today) => endOfQuarter(today),
  ],
  [THIS_WEEK]: [
    (today) =>
      startOfWeek(today, {
        weekStartsOn: 1,
      }),
    (today) => endOfWeek(today, { weekStartsOn: 1 }),
  ],
  [TODAY]: [(today) => today, (today) => today],
  [TOMORROW]: [(today) => addDays(today, 1), (today) => addDays(today, 1)],
  [YESTERDAY]: [(today) => addDays(today, -1), (today) => addDays(today, -1)],
};

export const getStartAndEndDates = (filterValue) => {
  const today = new Date();
  const [startFunction, endFunction] = filterDateRanges[filterValue] || [];
  return getDateRange(startFunction(today), endFunction(today));
};

export const getFilterValueFromDateRange = (startDate, endDate) => {
  const today = new Date();
  const startDateValue = startOfDay(new Date(startDate)).getTime();
  const endDateValue = startOfDay(new Date(endDate)).getTime();

  for (const [key, [startFunction, endFunction]] of Object.entries(
    filterDateRanges,
  )) {
    const startFunctionValue = startOfDay(startFunction(today)).getTime();
    const endFunctionValue = startOfDay(endFunction(today)).getTime();

    if (
      startFunctionValue === startDateValue &&
      endFunctionValue === endDateValue
    ) {
      return key;
    }
  }
  return CUSTOM;
};

  